export enum SuiviKit_Statut {
    Nouveau,
    EnCours,
    Traite
}

export class CommandeKitPretDTO {
    codeCommande = ''
    dateCommande = ''
    codeClient = ''
    produits: CommandeProduitKitPretDTO[] = []
    statut: SuiviKit_Statut = SuiviKit_Statut.Nouveau
    commentaires = ''
    userLastTraitement = ''
}

export class CommandeProduitKitPretDTO {
    codeProduit = ''
    datePeremption = ''
    nom = ''
    numeroIdentification = ''
}

export function SuiviKit_Statut_ToText(input: SuiviKit_Statut) {
    switch (input) {
        case SuiviKit_Statut.EnCours:
            return 'En cours'
        case SuiviKit_Statut.Nouveau:
            return 'Nouveau'
        case SuiviKit_Statut.Traite:
            return 'Traité'
    }
}
